//Constantes para que se definan las variables destinadas para las alertas al usuario

export const var_alerts  = {// se definen 
    registerlimite: 20, // numero maximo de transacciones que puede hacer el usuario antes de que lance la alerta de sincronizacion
    cuposlimite: 50, // numero minimo de transacciones, que alerta al usuario al llegar a agotarse
    dias_vecimiento: 7, // variables que se usa para alertar al usuario de que tiene 7 o menos dias para la fecha de expiracion del plan   
}
